import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../shared/material/material.module';
import { DashboardSummary } from '../models/dashboard-summary.interface';

/**
 * SummaryCardsComponent
 * Exibe métricas principais em cards visuais
 * Requirements: 1.1, 1.2, 6.1, 6.2, 6.3, 6.4, 6.5
 */
@Component({
  selector: 'app-summary-cards',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './summary-cards.component.html',
  styleUrls: ['./summary-cards.component.scss']
})
export class SummaryCardsComponent {
  /**
   * Dashboard summary data
   * Requirements: 1.1, 1.2
   */
  @Input() summary: DashboardSummary = {
    totalPlans: 0,
    activePlans: 0,
    monthlyTotal: 0,
    nextDueDate: null,
    overdueCount: 0,
    totalPaid: 0,
    totalPending: 0
  };

  /**
   * Check if there are active plans
   * Requirement: 1.1
   */
  get hasActivePlans(): boolean {
    return this.summary.activePlans > 0;
  }

  /**
   * Check if there are overdue installments
   * Requirement: 6.4
   */
  get hasOverdueInstallments(): boolean {
    return this.summary.overdueCount > 0;
  }

  /**
   * Check if there is a next due date
   * Requirement: 6.3
   */
  get hasNextDueDate(): boolean {
    return this.summary.nextDueDate !== null;
  }

  /**
   * Get formatted active plans ratio
   * Requirement: 1.1
   */
  get activePlansRatio(): string {
    return `${this.summary.activePlans}/${this.summary.totalPlans}`;
  }
}
